export default __webpack_public_path__ + "static/hero-image-mobile-dfd2a4b23a85a575b0b3ceaca057206b.png";